module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av465-c6bf9da398210f418daedfa6202fb817.jpg";